import { FC, useMemo } from "react";
import SubscriptionCubit from "src/state/SubscriptionCubit/SubscriptionCubit";
import { useBloc } from "src/state/state";

type ShowIfSubscriptionProps = {
  children: React.ReactNode;
  selfPayed?: boolean;
};

const ShowIfSubscription: FC<ShowIfSubscriptionProps> = ({
  children,
  ...props
}) => {
  const [, { extractPayerInfo }] = useBloc(SubscriptionCubit);
  const payerInfo = extractPayerInfo();

  const show = useMemo(() => {
    if (typeof props.selfPayed === "boolean") {
      const selfPayed = payerInfo.payerIsCashPay;
      if (selfPayed !== props.selfPayed) {
        return false;
      }
    }

    return true;
  }, [extractPayerInfo, props.selfPayed]);

  if (!show) {
    return null;
  }

  return children;
};

export default ShowIfSubscription;
